module.exports = __webpack_public_path__ + "5bb533f59e1408989555bcb7a8357af4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/loading.svg
// module id = 311
// module chunks = 0